import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import CupoyRouter from "components/commons/router/CupoyRouter";
import GLOBAL from 'jcolorglobal';

class DeleteEmptyInvoiceView extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            yearmonthList: [],
            yearmonth: undefined,
            comment: '',
        }
    }

    componentDidMount() {

        this.getEmptyInvoiceYearmonthList();
    }

    getEmptyInvoiceYearmonthList() {

        if(!Array.isArray(this.props.yearmonthList) || this.props.yearmonthList.length === 0) {
            this.props.emptyInvoiceActions.getEmptyInvoiceYearmonthList().then(()=>{

                this.initEmptyInvoiceYearmonthList();
            });
        } else {
            this.initEmptyInvoiceYearmonthList();
        }
    }

    initEmptyInvoiceYearmonthList() {
        const yearmonthList = this.getCanDeleteYearmonthList(this.props.yearmonthList);

        this.setState({
            yearmonth: yearmonthList.length > 0 ? yearmonthList[0] : undefined,
            yearmonthList: yearmonthList,
        });
    }

    getCanDeleteYearmonthList(yearmonthList) {

        var result = [];

        if(Array.isArray(yearmonthList) && yearmonthList.length > 0) {
            for(var i = 0; i < yearmonthList.length; i++) {
                var yearmonth = yearmonthList[i];
                if(yearmonth !== GLOBAL.NOW_YEARMONTH) {
                    result.push(yearmonth);
                }
            }
        }

        return result;
    }

    onInputChange(fieldname, event) {

        this.setState({
            [fieldname]: event.target.value,
        })
    }

    handleSubmit(event) {

        event.preventDefault();

        const {
            yearmonth,
            comment,
        } = this.state;

        this.props.webActions.openConfirmDialog({
            title: '下架空白發票',
            description: '確定下架「' + yearmonth + '」期的空白發票？',
            isPromise: true,
            confirmPromise: () => {

                const promise = new Promise((resolve, reject) => {
                    this.props.emptyInvoiceActions.delEmptyInvoice({
                        yearmonth: yearmonth,
                        comment: comment,
                    }).then((result) => {

                        if (result) {

                            resolve(true);

                            this.props.emptyInvoiceActions.getEmptyInvoiceYearmonthList();

                            this.props.webActions.cupoyStateGo(CupoyRouter.STATES.EMPTYINVOICE_LIST, {
                                page: 1
                            });

                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    }, (error) => {
                        if (error && error.message) {
                            reject(error.message);
                        } else {
                            reject('發生無法處理的錯誤，請聯絡工程師');
                        }
                    });
                });

                return promise;
            },
        });
    }

    render() {

        const {
            yearmonth,
            comment,
            yearmonthList,
         } = this.state;

        return (
            <div id="del-empty-invoice">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item active">
                            <a>下架空白發票</a>
                        </li>
                    </ul>
                    <div className="button-group">
                        <a className="button blue" onClick={this.handleSubmit}>
                            確定下架
                        </a>
                    </div>
                </div>
                <div className="scroll-content">
                    <div className="form">
                        <div className="block-form none-box-shadow">
                            <div className="block-form-row">
                                <div className="block-form-col">
                                    <h5 className="title">期別</h5>
                                    <div className="form-select">
                                        {yearmonthList.length === 0 ? '目前無發票可以下架' : ''}
                                        <select value={yearmonth} onChange={(event) => this.onInputChange('yearmonth', event)}>
                                            {yearmonthList.map((_yearmonth, index)=> {
                                                return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                            })}
                                        </select>
                                        <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div className="block-form-row">
                                <label className="block-form-col">
                                    <h5 className="title">備註</h5>
                                    <textarea
                                        type="text"
                                        value={comment}
                                        onChange={(event) => this.onInputChange('comment', event)}
                                        style={{height: '100px'}}
                                    />
                                </label>
                            </div>
                        </div>        
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state) {
    return {
        yearmonthList: state.emptyInvoice.yearmonthList,
    }
};

const mapActionToProps = function (dispatch) {
    return {
        emptyInvoiceActions: bindActionCreators(actionCreators.emptyInvoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(DeleteEmptyInvoiceView);


// WEBPACK FOOTER //
// ./src/components/emptyInvoice/DeleteEmptyInvoiceView.jsx